// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AiAssistantBar_assistantBar__Oanw2 {
  background: #232323;
  color: #fff;
  height: 65px;
  overflow: hidden;
  width: 100%;
  font: var(--font-32);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px 0 32px;
  box-sizing: border-box;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.AiAssistantBar_text__9rdju {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}

.AiAssistantBar_label__KBju0 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 14px;
  border-radius: 30px;
  background: rgba(24, 144, 255, 0.18);
  border: 1px solid rgba(24, 144, 255, 0.55);
  color: #fff;
  font: var(--font-30-bold);
  letter-spacing: 0.04em;
  flex: none;
}

.AiAssistantBar_message__Of2So {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.AiAssistantBar_pttBtn__p-hBM {
  -webkit-user-select: none;
          user-select: none;
  -webkit-tap-highlight-color: transparent;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 7px 22px;
  border-radius: 30px;
  font: var(--font-30-bold);
  background: rgba(58, 177, 99, 0.18);
  border: 1px solid rgba(58, 177, 99, 0.65);
  color: #fff;
  transition: transform 120ms ease, background 120ms ease, border-color 120ms ease;
}

.AiAssistantBar_pttBtn__p-hBM:active {
  transform: scale(0.98);
}

.AiAssistantBar_pttActive__TsLlV {
  background: rgba(255, 115, 92, 0.25);
  border-color: rgba(255, 115, 92, 0.8);
}

.AiAssistantBar_pttDisabled__RQ7Vh {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.14);
}

.AiAssistantBar_pttText__7CgbM {
  line-height: 1;
}

.AiAssistantBar_listening__Vfw-d {
  background: #1F2A21;
}

.AiAssistantBar_processing__SM9M6 {
  background: #1F242A;
}

.AiAssistantBar_speaking__kktVx {
  background: #1F1F2A;
}`, "",{"version":3,"sources":["webpack://./src/components/AiAssistantBar/AiAssistantBar.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,sBAAA;EACA,+CAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,oCAAA;EACA,0CAAA;EACA,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,UAAA;AACF;;AAEA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE,yBAAA;UAAA,iBAAA;EACA,wCAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mCAAA;EACA,yCAAA;EACA,WAAA;EACA,gFAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,oCAAA;EACA,qCAAA;AACF;;AAEA;EACE,qCAAA;EACA,uCAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF","sourcesContent":[".assistantBar {\n  background: #232323;\n  color: #fff;\n  height: 65px;\n  overflow: hidden;\n  width: 100%;\n  font: var(--font-32);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 20px 0 32px;\n  box-sizing: border-box;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.text {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  min-width: 0;\n}\n\n.label {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 14px;\n  border-radius: 30px;\n  background: rgba(24, 144, 255, 0.18);\n  border: 1px solid rgba(24, 144, 255, 0.55);\n  color: #fff;\n  font: var(--font-30-bold);\n  letter-spacing: 0.04em;\n  flex: none;\n}\n\n.message {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.pttBtn {\n  user-select: none;\n  -webkit-tap-highlight-color: transparent;\n  border: none;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 7px 22px;\n  border-radius: 30px;\n  font: var(--font-30-bold);\n  background: rgba(58, 177, 99, 0.18);\n  border: 1px solid rgba(58, 177, 99, 0.65);\n  color: #fff;\n  transition: transform 120ms ease, background 120ms ease, border-color 120ms ease;\n}\n\n.pttBtn:active {\n  transform: scale(0.98);\n}\n\n.pttActive {\n  background: rgba(255, 115, 92, 0.25);\n  border-color: rgba(255, 115, 92, 0.8);\n}\n\n.pttDisabled {\n  background: rgba(255, 255, 255, 0.06);\n  border-color: rgba(255, 255, 255, 0.14);\n}\n\n.pttText {\n  line-height: 1;\n}\n\n.listening {\n  background: #1F2A21;\n}\n\n.processing {\n  background: #1F242A;\n}\n\n.speaking {\n  background: #1F1F2A;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"assistantBar": `AiAssistantBar_assistantBar__Oanw2`,
	"text": `AiAssistantBar_text__9rdju`,
	"label": `AiAssistantBar_label__KBju0`,
	"message": `AiAssistantBar_message__Of2So`,
	"pttBtn": `AiAssistantBar_pttBtn__p-hBM`,
	"pttActive": `AiAssistantBar_pttActive__TsLlV`,
	"pttDisabled": `AiAssistantBar_pttDisabled__RQ7Vh`,
	"pttText": `AiAssistantBar_pttText__7CgbM`,
	"listening": `AiAssistantBar_listening__Vfw-d`,
	"processing": `AiAssistantBar_processing__SM9M6`,
	"speaking": `AiAssistantBar_speaking__kktVx`
};
export default ___CSS_LOADER_EXPORT___;
